const hasMap = typeof Map === 'function';
const hasSet = typeof Set === 'function';
const hasElementType = typeof Element !== 'undefined';
const hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

const isEqual = (a: unknown, b: unknown) => {
  if (a === b) {
    return true;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (a.constructor !== b.constructor) {
      return false;
    }

    let i;

    let length;

    if (Array.isArray(a)) {
      length = a.length;
      if (length !== (b as unknown[]).length) {
        return false;
      }

      for (i = length; i-- !== 0; ) {
        if (!isEqual(a[i], (b as unknown[])[i])) {
          return false;
        }
      }

      return true;
    }

    let it;

    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) {
        return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) {
          return false;
        }
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!isEqual(i.value[1], b.get(i.value[0]))) {
          return false;
        }
      }

      return true;
    }

    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) {
        return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) {
          return false;
        }
      }

      return true;
    }

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = (a as Uint8Array).length;
      if (length !== (b as Uint8Array).length) {
        return false;
      }
      for (i = length; i-- !== 0; ) {
        if ((a as Uint8Array)[i] !== (b as Uint8Array)[i]) {
          return false;
        }
      }
      return true;
    }

    if (a.constructor === RegExp) {
      return (
        (a as RegExp).source === (b as RegExp).source && (a as RegExp).flags === (b as RegExp).flags
      );
    }

    if (
      a.valueOf !== Object.prototype.valueOf &&
      typeof a.valueOf === 'function' &&
      typeof b.valueOf === 'function'
    ) {
      return a.valueOf() === b.valueOf();
    }
    if (
      a.toString !== Object.prototype.toString &&
      typeof a.toString === 'function' &&
      typeof b.toString === 'function'
    ) {
      return a.toString() === b.toString();
    }

    const keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0; ) {
      if (
        (keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') &&
        (a as { $$typeof: unknown }).$$typeof
      ) {
        continue;
      }

      if (
        !isEqual((a as Record<string, unknown>)[keys[i]], (b as Record<string, unknown>)[keys[i]])
      ) {
        return false;
      }
    }

    return true;
  }

  return a !== a && b !== b;
};

export default isEqual;
